import { forwardRef, useState } from 'react';
import * as R from 'ramda';
import BottomSheet from '@shared/components/BottomSheet';
import Text from '@shared/components/Text';
import IconChevronDown from '@shared/svg/ChevronDown';
import IconChevronUp from '@shared/svg/ChevronUp';
import event from '@shared/utils/events';
import type { SuggestionType } from '~/types/chat';
import { EVENT } from '~/utils/events';
import * as styles from './styles';
import SuggestionItem from './SuggestionItem';

type Props = {
  list?: SuggestionType[];
  children?: React.ReactNode;
  onClick?: (item: SuggestionType) => void;
  [key: string]: any;
};

function SuggestionList({ list, onClick = () => {} }: Props, ref?: any) {
  const [isBottomSheetOpen, setBottomSheetOpen] = useState<boolean>(false);
  const handleBottomSheet = (state: boolean) => {
    setBottomSheetOpen(() => state);
  };

  const handleClick = (item: SuggestionType) => {
    event(EVENT.SUBMIT, { content: item });
    handleBottomSheet(false);
    onClick(item);
  };

  return (
    <div css={styles.container}>
      <ul ref={ref} className="suggestion-list" css={styles.carousel}>
        {R.map((suggestion: SuggestionType) => (
          <li key={suggestion.label}>
            <SuggestionItem item={suggestion} onClick={handleClick} />
          </li>
        ))(list ?? [])}
      </ul>

      <div>
        <button css={styles.more} onClick={() => handleBottomSheet(true)}>
          <IconChevronUp size={16} />
        </button>
        <BottomSheet
          visible={isBottomSheetOpen}
          onClose={() => handleBottomSheet(false)}
        >
          <div css={styles.bottomsheet}>
            <div>
              <Text inline size="md" leading="md">
                이런 걸 물어볼 수 있어요
              </Text>
              <button onClick={() => handleBottomSheet(false)}>
                <IconChevronDown size={16} />
              </button>
            </div>
            <ul className="suggestion-list">
              {R.map((suggestion: SuggestionType) => (
                <li key={suggestion.label}>
                  <SuggestionItem item={suggestion} onClick={handleClick} />
                </li>
              ))(list ?? [])}
            </ul>
          </div>
        </BottomSheet>
      </div>
    </div>
  );
}

export default forwardRef(SuggestionList);
